const LabelGroup = ({ children }: {children: JSX.Element[]}) => {
  return (
    <dd className="grid grid-cols-2 sm:grid-cols-3 mt-3 gap-5">
      {children}
    </dd>
  )
}

export default LabelGroup